import React, { Component } from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react';
import { MessageBars } from '../Outils/MessageBars';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataReservation } from '../../data/DataReservation';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    onAffichePanelDonneesReservation
    onFermeFicheDonneesReservation
    classnameinner : classe CSS (string)
    className : classe CSS (string)
****************************************************************/

var objetState = {
    idOperation: 0,
    idReservation: 0,
    donneesReservation: [],
    groupesDonneesReservation: [],
    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

export class FicheDonneesReservation extends Component {
    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffichePanelDonneesReservation}
                type={PanelType.large}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                headerText="Valider les données de réservation"
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.className}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <DetailsList
                                items={this.state.donneesReservation}
                                columns={this.columns}
                                groups={this.state.groupesDonneesReservation}
                                selectionMode={SelectionMode.none}
                            />
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        this.columns = [
            {
                key: 'nomReelChamps', name: 'Nom réel du champ', fieldName: 'nomReelChamps', minWidth: 100, maxWidth: 200, isResizable: true,
            },
            {
                key: 'valeurChamps', name: 'Valeur', fieldName: 'valeurChamps', minWidth: 200, maxWidth: 300, isResizable: true,
            },
            {
                key: 'nomChamps', name: 'Nom dans le document', fieldName: 'nomChamps', minWidth: 100, maxWidth: 200, isResizable: true,
            }
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheDonneesReservation();
    }

    _chargementDonnees() {
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);

        if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Chargement des données de réservation"
            });

            let _chargementDonneesReservation = DataReservation._chargementDonneesReservation(this.props.idOperation, this.props.idReservation);

            _chargementDonneesReservation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;
                        let listeGroupes = [];

                        if (objetData.length > 0) {
                            let sectionTrav = objetData[0].section;
                            let nbSection = 0;
                            let depart = 0;

                            objetData.forEach(function (value, index) {
                                let section = value.section;

                                if (section === sectionTrav) {
                                    nbSection++;

                                    if (index === (objetData.length - 1)) {
                                        // Dernier de la liste
                                        listeGroupes.push({ key: sectionTrav, name: sectionTrav, startIndex: depart, count: nbSection });
                                    }
                                }
                                else {
                                    listeGroupes.push({ key: sectionTrav, name: sectionTrav, startIndex: depart, count: nbSection });

                                    sectionTrav = section;
                                    depart = (depart + nbSection);
                                    nbSection = 1;
                                }
                            });
                        }

                        let stateTemp = {};
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.donneesReservation = objetData;
                        stateTemp.groupesDonneesReservation = listeGroupes;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            let stateTemp = {};
            stateTemp.idReservation = 0;
            stateTemp.idOperation = 0;
            stateTemp.donneesReservation = [];
            stateTemp.groupesDonneesReservation = [];
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentDidMount() {
        //this._chargementDonnees();
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        //if (((this.props.idReservation !== undefined && this.props.idReservation !== this.state.idReservation)
        //    && (this.props.idOperation !== 0 && this.props.idOperation !== this.state.idOperation))
        //    && !this.state.enCoursDeTraitement
        //    && this.state.hideMessageBarError
        //    && this.state.hideMessageBarWarning) {
        //    this._chargementDonnees();
        //}
    }

    render() {
        return this._creationContent();
    }
}
